<template>
  <div class="row">
    <div class="col-md-12 marker-details">
      <h3>
        <span class="highlight">{{ $t("marker.event") }}:</span>
        {{getLocalizedProp(marker.name)}}
        <dropdown class="event-options">
          <span slot="trigger"
            class="glyphicon glyphicon-option-horizontal clickable options-trigger">
          </span>
          <ul slot="options" class="dropdown-menu show">
            <li>
              <router-link
                :to="{ path: `/marker/${marker.id}/edit` }">
                <span class="glyphicon glyphicon-pencil"></span>
                {{ $t('marker.edit') }}
              </router-link>
            </li>
            <li :class="{'disabled': !hasStarted}">
              <a href="#" v-on="hasStarted ? { click: downloadCsv } : { click: e => e.stopPropagation() }">
                <span class="glyphicon glyphicon-download-alt"></span>
                {{ $t('marker.download_csv') }}
              </a>
            </li>
            <li>
              <ftp-sync-button :marker-id="marker.id"></ftp-sync-button>
            </li>
          </ul>
        </dropdown>
      </h3>
      <p><span class="highlight">{{ $t("marker.start_date") }}:</span>
         <date :value="marker.starts_at"></date> <span class="separator">&bullet;</span>
         <span class="highlight">{{ $t("marker.end_date") }}:</span>
         <date :value="marker.ends_at"></date>
      </p>
    </div>
  </div>
</template>

<script>
// Marker details component
// Show basic information about a marker

import http from '../../services/http'
import auth from '../../services/auth'
import Dropdown from '../generic/Dropdown.vue'
import FtpSyncButton from './FTPSyncButton.vue'
import moment from 'moment'

// locales in fallback order
const locales = ['en', 'fr', 'nl']

export default {
  props: [
    'marker'
  ],
  components: {
    Dropdown,
    FtpSyncButton
  },
  data () {
    return {
      showOptions: false
    }
  },
  methods: {
    // Retrieve the value of a translated field in the current language
    getLocalizedProp (obj) {
      let locale = this.currentLocale
      if (obj[locale]) {
        return obj[locale]
      }
      for (let l of locales) {
        if (obj[l]) {
          return obj[l]
        }
      }
    },
    downloadCsv () {
      // get the csv signed link and redirect to it
      http.get(`/marker/${this.marker.id}/csv/`, auth.getAuthHeader())
      .then((response) => {
        if (response.url) {
          window.location = response.url
        }
      })
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    hasStarted () {
      return this.marker.starts_at.isBefore(moment())
    }
  }
}
</script>
